import trainingService from "./useTrainingCardListService";
import { useQuery } from "react-query";
import useDebounce from "../../../../../core/hooks/useDebounce";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { message } from "antd";
import { useMutation } from "react-query";
import coursesService from "../../CardList/logic/useCardListService";
import dayjs from "dayjs";
const useTrainingCardList = (
  isUpcomingTraining,
  sessionData,
  handleCancel,
  setCurrentStep,
) => {
  const {
    control,
    formState: { errors },
    reset,
    watch,
    handleSubmit,
    setValue,
  } = useForm();
  const [search, setSearch] = useState("");
  const { debouncedValue } = useDebounce(search, 1000);
  const [page, setPage] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const {
    data,
    isLoading,
    isFetching : isFetchingTraining,
    error,
    refetch: refetchTraining,
  } = useQuery(
    ["trainingsData", debouncedValue, page, isUpcomingTraining],
    () => trainingService.getTrainingsService(debouncedValue, page, 11, isUpcomingTraining),
    {
      initialData: {
        data: { data: [], meta: { hasPrevious: false, hasNext: false } },
      },
      keepPreviousData: true,
      // staleTime: 5000
    }
  );
  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
  };
  const { data: filtredUsersData } = useQuery("filterUsers", () =>
    trainingService.filterUsersByRole(["Trainer"]),
    {
      enabled: isModalOpen,
    }
  );


  const { data: courseData } = useQuery("allCourses", () =>
    coursesService.getCoursesData(),
    {
      enabled: isModalOpen,
    }
  );

  const selectedUsers = filtredUsersData?.data
    ? filtredUsersData?.data?.map((user) => ({
        value: user.id,
        label: user.firstName + " " + user.lastName,
      }))
    : [];

  const courseOptions = courseData?.data.data
    ? courseData?.data?.data?.map((course) => ({
        value: course.id,
        label: course.title,
      }))
    : [];

  const [selectedOptionLanguage, setSelectedOptionLanguage] = useState([
    {
      value: "english",
      label: "English",
    },
    {
      value: "french",
      label: "French",
    },
    {
      value: "spanish",
      label: "Japanese",
    },
  ]);

  function handleSearchChange(event) {
    setSearch(event.target.value);
  }

  const handleNext = () => {
    setPage((page) => page + 1);
  };

  const handlePrevious = () => {
    setPage((page) => page - 1);
  };

  const handleDeleteTraining = async (id, e) => {
    e.stopPropagation();
    try {
      await trainingService.deleteTraining(id);
      await refetchTraining();
      message.success("Training deleted successfully");
    } catch (error) {
      console.log(error);
      message.warning(
        "cannot delete this training because it is already started"
      );
    }
  };
  function handleCategoryChange(event) {
    setSearch(event.target.value);
    setPage(1);
  }

  const createTrainingMutation = useMutation(
    (formData) => trainingService.addTraining(formData),
    {
      onSuccess: () => {
        refetchTraining();
        reset();
        handleCancel();
        setCurrentStep(0);
        message.success("Training created successfully");
      },
      onError: (error) => {
        console.error("Error creating training:", error);
        message.error("Failed to create training");
      },
    }
  );

  const onSubmitTraining = () => {
    const flattenedSessionData = Object.values(sessionData).flat();
    const intermediateStartDate = dayjs(watch("rangeDate")[0]).unix();
    const intermediateEndDate = dayjs(watch("rangeDate")[1]).unix();
    const formData = {
      start_date: dayjs.unix(intermediateStartDate).format("YYYY-MM-DD"),
      end_date: dayjs.unix(intermediateEndDate).format("YYYY-MM-DD"),
      neededEquipment: watch("equipment"),
      isDeleted: false,
      isGuaranteed: watch("isGuaranteed"),
      language: watch("language"),
      location: watch("location"),
      courseId: watch("course"),
      trainerId: watch("trainer"),
      sessions: flattenedSessionData,
    };
    createTrainingMutation.mutate(formData);
  };

  const [sessionsToApply, setSessionsToApply] = useState([{
    from: null,
    to: null,
  }]);

  const handleAddSessionToApply = () => {
    const newSessionsToApply = [...sessionsToApply];
    newSessionsToApply.push({
      from: null,
      to: null,
    });
    setSessionsToApply(newSessionsToApply); 
  }

  const handleFetchAll = async () =>{
    setSearch("")
    await refetchTraining();
  }

  const handleDeleteSessionToApply = () => {
    const newSessionsToApply = [...sessionsToApply];
    if (sessionsToApply && sessionsToApply.length > 1) {
      newSessionsToApply.pop();
      setSessionsToApply(newSessionsToApply);
    }
  }



  return {
    data: data?.data?.data,
    meta: data?.data?.meta,
    handleNext,
    handlePrevious,
    isLoading,
    error,
    handleSearchChange,
    reset,
    isModalOpen,
    setIsModalOpen,
    openModal,
    selectedUsers,
    courseOptions,
    handleSubmit,
    errors,
    control,
    selectedOptionLanguage,
    setSelectedOptionLanguage,
    refetchTraining,
    handleDeleteTraining,
    watch,
    onSubmitTraining,
    setValue,
    handleAddSessionToApply,
    handleDeleteSessionToApply,
    sessionsToApply,
    setSessionsToApply,
    isFetchingTraining,
    handlePageClick,
    handleCategoryChange,
    handleFetchAll
  };
};

export default useTrainingCardList;
